// Columbus 1919 — homepage split-screen hero
// Hover snaps to Components (left) or Tubing (right), auto-filling the active
// panel. A centre buffer with hysteresis prevents rapid switching near the
// middle. RAF easing, click-to-navigate, ESC to release.
(function () {
  const hero = document.querySelector('.ch-hero');
  if (!hero) return;

  // ─── Touch / narrow screens: skip the hover-scrub interaction ───────────
  // The CSS collapses the hero into a stacked, tappable layout under the same
  // conditions; the panels' own links handle navigation, so the split logic
  // (mousemove/click-to-navigate) must NOT run — it would hijack taps.
  const staticLayout =
    window.matchMedia('(max-width: 768px)').matches ||
    window.matchMedia('(hover: none) and (pointer: coarse)').matches;
  if (staticLayout) return;

  // Navigation targets for the two sides
  const componentsUrl = hero.dataset.componentsUrl || '';
  const tubingUrl     = hero.dataset.tubingUrl     || '';

  const TWEAKS = {
    fill: 90,         // % split the active side expands to (near-full reveal)
    enterBuffer: 8,   // % past centre needed to activate a side from neutral (42% / 58%)
    switchBuffer: 14, // % past centre needed to flip to the other side once active (36% / 64%)
    easeSpeed: 4.5,   // exp ease speed (higher = snappier)
  };

  const componentsPanel = hero.querySelector('.ch-hero__panel--components');
  const tubingPanel     = hero.querySelector('.ch-hero__panel--tubing');
  const centerline      = hero.querySelector('.ch-hero__centerline');
  const paneldoves      = hero.querySelectorAll('.ch-hero__paneldove');
  const centerWrapBlack = hero.querySelector('.ch-hero__centerwrap--white');
  const centerWrapRed   = hero.querySelector('.ch-hero__centerwrap--black');
  const centerLayer     = hero.querySelector('.ch-hero__center');

  let split = 50;
  let target = 50;
  let committed = null; // 'left' | 'right' | null
  let hoverSide = null; // 'left' | 'right' | null (neutral) — active hovered panel
  let rafId;

  const clamp = (v, a, b) => Math.max(a, Math.min(b, v));

  function applySplit(s) {
    componentsPanel.style.clipPath = `polygon(0 0, ${s}% 0, ${s}% 100%, 0 100%)`;
    tubingPanel.style.clipPath     = `polygon(${s}% 0, 100% 0, 100% 100%, ${s}% 100%)`;
    if (centerline) centerline.style.left = `${s}%`;

    // Each dove is clipped along with its own panel, so no per-side clipping is
    // needed here — just a subtle parallax drift as the split moves. Opacity
    // (rest vs active vs committed) is handled in CSS via data-side/data-committed.
    const drift = (s - 50) / 50;
    const doveT = `translate(-50%, calc(-50% + 1.5vh)) translateX(${drift * 14}px) rotate(${drift * 2}deg)`;
    paneldoves.forEach(function (d) { d.style.transform = doveT; });

    if (centerLayer) {
      const fade = committed ? 0 : clamp(1 - Math.abs(s - 50) / 45, 0, 1);
      centerLayer.style.opacity = fade;
    }
    if (centerWrapBlack) centerWrapBlack.style.clipPath = `inset(0 ${100 - s}% 0 0)`;
    if (centerWrapRed)   centerWrapRed.style.clipPath   = `inset(0 0 0 ${s}%)`;

    if (!committed) {
      if (s > 52) hero.dataset.side = 'left';
      else if (s < 48) hero.dataset.side = 'right';
      else delete hero.dataset.side;
    }
  }

  function tick(now) {
    if (!tick._last) tick._last = now;
    const dt = Math.min(0.05, (now - tick._last) / 1000);
    tick._last = now;
    const k = 1 - Math.exp(-TWEAKS.easeSpeed * dt);
    const next = split + (target - split) * k;
    if (Math.abs(next - target) < 0.04) split = target;
    else split = next;
    applySplit(split);
    rafId = requestAnimationFrame(tick);
  }

  function onMove(e) {
    if (committed) return;
    const r = hero.getBoundingClientRect();
    const xPct = ((e.clientX - r.left) / r.width) * 100; // 0..100

    // Hysteresis: from neutral a modest nudge past centre activates a side and
    // auto-fills it; once a side is active the cursor must cross well past centre
    // (the wider switch buffer) to flip, so hovering near the middle never
    // rapid-switches between the two.
    if (hoverSide === 'left') {
      if (xPct > 50 + TWEAKS.switchBuffer) hoverSide = 'right';
    } else if (hoverSide === 'right') {
      if (xPct < 50 - TWEAKS.switchBuffer) hoverSide = 'left';
    } else {
      if (xPct < 50 - TWEAKS.enterBuffer) hoverSide = 'left';
      else if (xPct > 50 + TWEAKS.enterBuffer) hoverSide = 'right';
    }

    if (hoverSide === 'left')       target = TWEAKS.fill;
    else if (hoverSide === 'right') target = 100 - TWEAKS.fill;
    else                            target = 50;
  }

  function onLeave() {
    if (!committed) { hoverSide = null; target = 50; }
  }

  function onClick(e) {
    if (e.target.closest('.ch-hero__back')) return;
    if (committed) { release(); return; }
    // Prefer the auto-filled side; fall back to cursor position if still neutral.
    let side = hoverSide;
    if (!side) {
      const r = hero.getBoundingClientRect();
      side = (e.clientX - r.left) / r.width < 0.5 ? 'left' : 'right';
    }
    let destination = '';
    if (side === 'left') {
      committed = 'left';  target = 100;
      hero.dataset.committed = 'left';  hero.dataset.side = 'left';
      destination = componentsUrl;
    } else {
      committed = 'right'; target = 0;
      hero.dataset.committed = 'right'; hero.dataset.side = 'right';
      destination = tubingUrl;
    }
    if (destination) {
      // Let the commit animation play briefly so the click feels confirmed,
      // then navigate to the chosen side's page.
      window.setTimeout(function () { window.location.href = destination; }, 420);
    }
  }

  function release() {
    committed = null;
    hoverSide = null;
    target = 50;
    delete hero.dataset.committed;
    delete hero.dataset.side;
  }

  function onKey(e) {
    if (e.key === 'Escape' && committed) release();
  }

  hero.addEventListener('mousemove', onMove);
  hero.addEventListener('mouseleave', onLeave);
  hero.addEventListener('click', onClick);
  window.addEventListener('keydown', onKey);
  const backBtn = hero.querySelector('.ch-hero__back');
  if (backBtn) backBtn.addEventListener('click', function (e) { e.stopPropagation(); release(); });

  applySplit(50);
  rafId = requestAnimationFrame(tick);
})();
